import React, { Suspense } from 'react'
import { FormattedMessage } from 'react-intl'
import Header from 'src/components/Header/Header'
import Loading from 'src/components/Loading/Loading'
import ResponsiveTabs from 'src/components/ResponsiveTabs/ResponsiveTabs'
import Users from './Users/Users'
import Assets from './Assets/Assets'

import './Home.sass'

const Home = () => {
  return (
    <div id="home" className="page">
      <Header />
      <section id="page-content">
        <div className="container">
          <ResponsiveTabs
            headers={[
              <FormattedMessage id="home.tab-assets" />,
              <FormattedMessage id="home.tab-users" />
            ]}
            tabs={[
              <Suspense fallback={<Loading />}>
                <Assets />
              </Suspense>,
              <Suspense fallback={<Loading />}>
                <Users />
              </Suspense>
            ]}
          />
        </div>
      </section>
    </div>
  )
}

export default Home
